import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PageBlock } from '../../../common/services';
import {ImageBlock, TextBlock} from '../../../common/services/page';


@Component({
  selector: 'p8-bdc-page-blocks',
  templateUrl: './page-blocks.component.html',
  styleUrls: ['./page-blocks.component.scss']
})
export class PageBlocksComponent implements OnInit {
  @Input() body: PageBlock[];
  @Output() newBlock: EventEmitter<any> = new EventEmitter();

  @Output() blockImageChange: EventEmitter<any> = new EventEmitter();
  @Output() blockTextChange: EventEmitter<TextBlock> = new EventEmitter<TextBlock>();

  currentBlock: number = null;

  constructor() { }

  ngOnInit() {
  }

  onBlockImageChange(imgBlock) {
    this.blockImageChange.emit(imgBlock);
  }

  onMouseEnter(index: number) {
    this.currentBlock = index;
  }

  onMouseLeave(index: number) {
    this.currentBlock = null;
  }

  swap(array: any[], x, y) {
    const temp = array[x];
    array[x] = array[y];
    array[y] = temp;
  }

  moveUp(index: number) {
    this.swap(this.body, index, index - 1);
  }

  moveDown(index: number) {
    this.swap(this.body, index, index + 1);
  }

  remove(index: number) {
    const block = this.body[index];
    if (block.type === 'image') {
      this.blockImageChange.emit({block: block, action: 'del'});
    }

    this.body.splice(index, 1);
  }

  addBlock($event: any, index: number) {
    this.newBlock.emit({type: $event.type, index: index});
  }
}
